<template>
  <header
    id="top"
    class="hoverable fixed-top"
  >
    <nav class="navbar navbar-expand-md navbar-dark bg-dark">
      <a
        class="navbar-brand"
        href="#"
      >
        <svg
          height="30"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 284.98 56.27"
        >
          <title>BMG</title>
          <g
            id="Layer_2"
            data-name="Layer 2"
          >
            <g
              id="Layer_1-2"
              data-name="Layer 1"
            >
              <g id="Logo_Hor_Full">
                <g id="BMG_Logo_Medical_Group">
                  <path
                    id="Name_Group_P"
                    class="bmg-logo-svg-1"
                    d="M275.51,43.13h4.74c2.85,0,4.73,1.52,4.73,4v0c0,2.73-2.28,4.14-5,4.14h-3.07v4.46h-1.43ZM280.06,50c2.1,0,3.47-1.12,3.47-2.78v0c0-1.81-1.35-2.75-3.39-2.75h-3.2V50Z"
                  />
                  <path
                    id="Name_Group_U"
                    class="bmg-logo-svg-1"
                    d="M255.38,50.49V43.13h1.43V50.4c0,2.73,1.47,4.26,3.87,4.26s3.81-1.41,3.81-4.17V43.13h1.43v7.25c0,3.69-2.11,5.6-5.28,5.6S255.38,54.07,255.38,50.49Z"
                  />
                  <path
                    id="Name_Group_O"
                    class="bmg-logo-svg-1"
                    d="M233.61,49.49v0a6.41,6.41,0,0,1,6.47-6.54,6.34,6.34,0,0,1,6.43,6.5v0a6.45,6.45,0,1,1-12.9,0Zm11.42,0v0a5,5,0,0,0-5-5.22,5,5,0,0,0-4.95,5.18v0a5,5,0,0,0,5,5.22A5,5,0,0,0,245,49.49Z"
                  />
                  <path
                    id="Name_Group_R"
                    class="bmg-logo-svg-1"
                    d="M215.3,43.13h5.44a5,5,0,0,1,3.6,1.27,3.5,3.5,0,0,1,1,2.49v0c0,2.09-1.44,3.32-3.43,3.69l3.88,5.16H224l-3.67-4.91h-3.61v4.91H215.3Zm5.31,6.45c1.9,0,3.26-1,3.26-2.6v0c0-1.56-1.2-2.5-3.24-2.5h-3.9v5.13Z"
                  />
                  <path
                    id="Name_Group_G"
                    class="bmg-logo-svg-1"
                    d="M194.39,49.49v0a6.35,6.35,0,0,1,6.34-6.54,6.65,6.65,0,0,1,4.72,1.68l-.92,1.08a5.38,5.38,0,0,0-3.85-1.44,4.94,4.94,0,0,0-4.81,5.18v0c0,3,1.94,5.26,5,5.26a5.94,5.94,0,0,0,3.65-1.27V50.31h-3.85V49h5.22v5A7.68,7.68,0,0,1,200.82,56,6.2,6.2,0,0,1,194.39,49.49Z"
                  />
                  <path
                    id="Name_Medical_L"
                    class="bmg-logo-svg-1"
                    d="M165.8,43.13h1.43V54.46h7.12v1.32H165.8Z"
                  />
                  <path
                    id="Name_Medical_A"
                    class="bmg-logo-svg-1"
                    d="M150.28,43h1.34l5.76,12.74h-1.53l-1.49-3.34h-6.88L146,55.78h-1.46Zm3.52,8.1-2.87-6.43L148,51.14Z"
                  />
                  <path
                    id="Name_Medical_C"
                    class="bmg-logo-svg-1"
                    d="M125.6,49.49v0a6.37,6.37,0,0,1,6.4-6.54,6.58,6.58,0,0,1,4.93,2l-1,1a5.51,5.51,0,0,0-4-1.73,5,5,0,0,0-4.9,5.18v0a5,5,0,0,0,4.9,5.22,5.51,5.51,0,0,0,4.08-1.82l.94.92A6.6,6.6,0,0,1,131.94,56,6.31,6.31,0,0,1,125.6,49.49Z"
                  />
                  <path
                    id="Name_Medical_I"
                    class="bmg-logo-svg-1"
                    d="M115,43.13h1.43V55.78H115Z"
                  />
                  <path
                    id="Name_Medical_D"
                    class="bmg-logo-svg-1"
                    d="M94.78,43.13h4.39c4,0,6.72,2.73,6.72,6.29v0c0,3.56-2.74,6.32-6.72,6.32H94.78Zm1.43,1.32v10h3a4.89,4.89,0,0,0,5.24-5v0a4.93,4.93,0,0,0-5.24-5Z"
                  />
                  <path
                    id="Name_Medical_E"
                    class="bmg-logo-svg-1"
                    d="M76.85,43.13H86v1.3H78.28v4.32h6.9v1.31h-6.9v4.42h7.8v1.3H76.85Z"
                  />
                  <path
                    id="Name_Medical_M"
                    class="bmg-logo-svg-1"
                    d="M55,43.13h1.45L61.05,50l4.61-6.91h1.45V55.78H65.68V45.54l-4.61,6.77H61l-4.61-6.75V55.78H55Z"
                  />
                </g>
                <!-- <g id="BMG_Logo_Dark_Bridging">
                  <path id="Name_Bridging_Dark_G2" class="bmg-logo-svg-2" d="M253.55,16.62v-.09A16.39,16.39,0,0,1,270.29,0c5.75,0,9.22,1.55,12.55,4.38l-4.43,5.34a11.71,11.71,0,0,0-8.34-3.24c-5.11,0-9.17,4.51-9.17,9.94v.09c0,5.84,4,10.13,9.67,10.13a11.19,11.19,0,0,0,6.61-1.92V20.18h-7.07V14.12H284V28a20.7,20.7,0,0,1-13.64,5.07C260.39,33.05,253.55,26.07,253.55,16.62Z"/>
                  <path id="Name_Bridging_Dark_N" class="bmg-logo-svg-2" d="M219.53.57H226l15,19.66V.57h6.94V32.5h-6L226.47,12.2V32.5h-6.94Z"/>
                  <path id="Name_Bridging_Dark_I2" class="bmg-logo-svg-2" d="M205.17.57h7V32.5h-7Z"/>
                  <path id="Name_Bridging_Dark_G" class="bmg-logo-svg-2" d="M168,16.62v-.09A16.39,16.39,0,0,1,184.78,0c5.74,0,9.21,1.55,12.54,4.38L192.9,9.74a11.75,11.75,0,0,0-8.35-3.24c-5.11,0-9.17,4.51-9.17,9.94v.09c0,5.84,4,10.13,9.67,10.13a11.22,11.22,0,0,0,6.62-1.92V20.18h-7.08V14.12h13.87V28a20.68,20.68,0,0,1-13.64,5.07C174.88,33.05,168,26.07,168,16.62Z"/>
                  <path id="Name_Bridging_Dark_D" class="bmg-logo-svg-2" d="M134.69.57h12.45c10,0,17,6.89,17,15.87v.09c0,9-6.93,16-17,16H134.69Zm7,6.34V26.16h5.43c5.75,0,9.63-3.88,9.63-9.54v-.09a9.17,9.17,0,0,0-9.63-9.62Z"/>
                  <path id="Name_Bridging_Dark_I" class="bmg-logo-svg-2" d="M120.33.57h7V32.5h-7Z"/>
                  <path id="Name_Bridging_Dark_R" class="bmg-logo-svg-2" d="M87.68.57h14.59c4.06,0,7.21,1.14,9.31,3.24a10,10,0,0,1,2.74,7.29v.1a9.92,9.92,0,0,1-6.84,9.9l7.8,11.4h-8.22l-6.84-10.22H94.7V32.5h-7Zm14.14,15.51c3.42,0,5.38-1.83,5.38-4.52v-.09c0-3-2.1-4.56-5.52-4.56h-7v9.17Z"/>
                  <path id="Name_Bridging_Dark_B" class="bmg-logo-svg-2" d="M55,.57H69.83c3.65,0,6.52,1,8.34,2.83a7.29,7.29,0,0,1,2.19,5.42v.1a7.41,7.41,0,0,1-4.19,6.88c3.69,1.42,6,3.56,6,7.85v.09c0,5.84-4.74,8.76-12,8.76H55ZM73.38,10c0-2.1-1.64-3.28-4.6-3.28H61.84v6.75h6.48c3.1,0,5.06-1,5.06-3.38ZM70,19.32H61.84v7h8.35c3.1,0,5-1.09,5-3.47v-.09C75.16,20.64,73.57,19.32,70,19.32Z"/>
                </g> -->
                <g id="BMG_Logo_White_Bridging">
                  <path
                    id="Name_Bridging_White_G2"
                    class="bmg-logo-svg-3"
                    d="M253.66,16.61v-.1A16.4,16.4,0,0,1,270.41,0c5.75,0,9.21,1.55,12.54,4.38l-4.42,5.34a11.75,11.75,0,0,0-8.35-3.24c-5.11,0-9.17,4.51-9.17,9.94v.09c0,5.84,4,10.13,9.67,10.13a11.27,11.27,0,0,0,6.62-1.91V20.16h-7.08V14.1h13.87V28A20.68,20.68,0,0,1,270.45,33C260.51,33,253.66,26.05,253.66,16.61Z"
                  />
                  <path
                    id="Name_Bridging_White_N"
                    class="bmg-logo-svg-3"
                    d="M219.65.55h6.47l15,19.66V.55H248V32.48h-6l-15.47-20.3v20.3h-6.93Z"
                  />
                  <path
                    id="Name_Bridging_White_I2"
                    class="bmg-logo-svg-3"
                    d="M205.29.55h7V32.48h-7Z"
                  />
                  <path
                    id="Name_Bridging_White_G"
                    class="bmg-logo-svg-3"
                    d="M168.15,16.61v-.1A16.39,16.39,0,0,1,184.89,0c5.75,0,9.21,1.55,12.54,4.38L193,9.72a11.72,11.72,0,0,0-8.35-3.24c-5.11,0-9.17,4.51-9.17,9.94v.09c0,5.84,4,10.13,9.67,10.13a11.27,11.27,0,0,0,6.62-1.91V20.16h-7.07V14.1h13.87V28A20.72,20.72,0,0,1,184.94,33C175,33,168.15,26.05,168.15,16.61Z"
                  />
                  <path
                    id="Name_Bridging_White_D"
                    class="bmg-logo-svg-3"
                    d="M134.8.55h12.45c10,0,17,6.89,17,15.87v.09c0,9-6.93,16-17,16H134.8Zm7,6.34V26.14h5.42c5.75,0,9.63-3.88,9.63-9.53v-.1a9.17,9.17,0,0,0-9.63-9.62Z"
                  />
                  <path
                    id="Name_Bridging_White_I"
                    class="bmg-logo-svg-3"
                    d="M120.44.55h7V32.48h-7Z"
                  />
                  <path
                    id="Name_Bridging_White_R"
                    class="bmg-logo-svg-3"
                    d="M87.79.55h14.6c4.06,0,7.21,1.14,9.3,3.24a10,10,0,0,1,2.74,7.3v.09a9.92,9.92,0,0,1-6.84,9.9l7.8,11.4h-8.21l-6.84-10.22H94.82V32.48h-7Zm14.14,15.51c3.42,0,5.38-1.83,5.38-4.52v-.09c0-3-2.09-4.56-5.52-4.56h-7v9.17Z"
                  />
                  <path
                    id="Name_Bridging_White_B"
                    class="bmg-logo-svg-3"
                    d="M55.11.55H69.94c3.65,0,6.52,1,8.35,2.83A7.3,7.3,0,0,1,80.48,8.8v.1a7.41,7.41,0,0,1-4.2,6.88c3.7,1.42,6,3.56,6,7.85v.09c0,5.84-4.75,8.76-12,8.76H55.11ZM73.5,10c0-2.1-1.64-3.28-4.61-3.28H62v6.75h6.47c3.11,0,5.07-1,5.07-3.38ZM70.08,19.3H62v7H70.3c3.11,0,5-1.09,5-3.46v-.1C75.28,20.62,73.68,19.3,70.08,19.3Z"
                  />
                </g>
                <g id="BMG_Logo_Icon">
                  <path
                    id="Right_1"
                    class="bmg-logo-svg-4"
                    d="M32.51,0H30.29c0,18.8,8.58,36.19,21.85,44.31V41.67C40.17,33.66,32.51,17.49,32.51,0Z"
                  />
                  <path
                    id="Right_2"
                    class="bmg-logo-svg-4"
                    d="M27.18,0H25c0,22.21,10.66,42,27.18,50.39V47.87C36.94,39.55,27.18,20.93,27.18,0Z"
                  />
                  <path
                    id="Right_3"
                    class="bmg-logo-svg-4"
                    d="M21.85,0H19.63c0,25.19,13.06,47.77,32.51,56.27V53.82C34,45.38,21.85,23.93,21.85,0Z"
                  />
                  <path
                    id="Left_1"
                    class="bmg-logo-svg-1"
                    d="M19.63,0h2.22c0,18.8-8.58,36.19-21.85,44.31V41.67C12,33.66,19.63,17.49,19.63,0Z"
                  />
                  <path
                    id="Left_2"
                    class="bmg-logo-svg-1"
                    d="M25,0h2.22C27.18,22.21,16.51,42,0,50.39V47.87C15.2,39.55,25,20.93,25,0Z"
                  />
                  <path
                    id="Left_3"
                    class="bmg-logo-svg-1"
                    d="M30.29,0h2.22C32.51,25.19,19.45,47.77,0,56.27V53.82C18.16,45.38,30.29,23.93,30.29,0Z"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      </a>
      <!-- The toggler that shows when the screen is small -->
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon" />
      </button>

      <div
        v-if="!atLogin"
        class="collapse navbar-collapse justify-content-end"
        id="navbarSupportedContent"
      >
        <ul class="navbar-nav">
          <li class="nav-item">
            <router-link
              :to="{ name: 'Login', params: { section: 'top' }}"
              class="nav-link"
            >
              Login
            </router-link>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>

export default {
  name: 'EmptyHeader',
  props: [],
  data () {
    return {
      showLinks: false
    }
  },
  components: {},
  methods: {},
  computed: {
    atLogin () {
      return '/login' === this.$route.path
    }
  },
  mounted () {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
